<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Get Live Remitone Exchange Rates</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between py-3"
            >
              <div
                class="filter-select d-flex flex-md-row flex-column mt-3 mt-lg-0"
              >
                <div
                  class="country-dropdown curancy-dropdown mb-0 mt-md-0 mt-3"
                >
                  <div class="form-group form-select single-multiselect mb-0">
                    <span class="float-label">
                      <label for="roles">Select Source Country</label>
                      <multiselect
                        placeholder=""
                        v-model="selectedCountry"
                        :show-labels="false"
                        :options="countryList"
                        :searchable="false"
                        label="countryname"
                        track-by="countryid"
                      >
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span
                              :class="
                                'flag-icon flag-icon-' +
                                props.option.isocode.toLowerCase() +
                                ' fi-md fi-round '
                              "
                            ></span>
                            <span class="option__title">
                              {{ props.option.name }}
                            </span>
                          </div>
                        </template>
                      </multiselect>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <b-button size="lg" variant="primary btn-mw">
                    Update Rates from RemitOne API
                  </b-button>
                </div>
              </div>
            </div>
            <b-table
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #thead-top>
                <tr>
                  <th rowspan="2" class="th-middle">Source Country</th>
                  <th rowspan="2" class="th-middle">Destination Country</th>
                  <th colspan="6" class="text-center border-left">
                    Exchange Rate
                  </th>
                </tr>
                <tr>
                  <th class="border-left text-center">Account</th>
                  <th class="text-center">Cash Collection</th>
                  <th class="text-center">Card</th>
                  <th class="text-center">Home Delivery</th>
                  <th class="text-center">Utility Bill</th>
                  <th class="text-center">Mobile Transfer</th>
                </tr>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
              v-if="totalRows > 10"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  hide-goto-end-buttons
                  hide-ellipsis
                  prev-text="Previous page"
                  next-text="Next page"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
import { mapGetters } from "vuex";
export default {
  name: "RemitOneLiveRates",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
  },
  data() {
    return {
      selectedCountry: [],
      items: [
        {
          source_country: "Australia",
          destination_country: "Ghana",
          account: "10.4525",
          cash_collection: "10.4525",
          card: "10.4525",
          home_delivery: "10.4525",
          utility_bill: "10.4525",
          mobile_transfer: "10.4525",
        },
        {
          source_country: "Australia",
          destination_country: "Nigeria",
          account: "1096.81",
          cash_collection: "1096.81",
          card: "1096.81",
          home_delivery: "1096.81",
          utility_bill: "1096.81",
          mobile_transfer: "1096.81",
        },
        {
          source_country: "Australia",
          destination_country: "Benin",
          account: "396.156",
          cash_collection: "396.156",
          card: "396.156",
          home_delivery: "396.156",
          utility_bill: "396.156",
          mobile_transfer: "396.156",
        },
        {
          source_country: "Australia",
          destination_country: "Equatorial Guinea",
          account: "396.156",
          cash_collection: "396.156",
          card: "396.156",
          home_delivery: "396.156",
          utility_bill: "396.156",
          mobile_transfer: "396.156",
        },
        {
          source_country: "Australia",
          destination_country: "Gabon",
          account: "396.156",
          cash_collection: "396.156",
          card: "396.156",
          home_delivery: "396.156",
          utility_bill: "396.156",
          mobile_transfer: "396.156",
        },
      ],
      fields: [
        {
          key: "source_country",
          label: "Source Country",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "destination_country",
          label: "Destination Country",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "account",
          label: "Account",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "cash_collection",
          label: "Cash Collection",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "card",
          label: "Card",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "home_delivery",
          label: "Home Delivery",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "utility_bill",
          label: "Utility Bill",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
        {
          key: "mobile_transfer",
          label: "Mobile Transfer",
          sortable: true,
          formatter: "key",
          thClass: "d-none",
          tdClass: "text-center",
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    //
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
};
</script>
<style>
thead th {
  padding: 5px !important;
}
.th-middle {
  vertical-align: middle !important;
  text-align: center;
}
</style>
